import ScrollReveal from "@/components/base/ScrollReveal";

export default function InstagramFeed() {
  const posts = [
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/281e5a95be72493bd34d4f92d81034f6.png", url: "https://www.instagram.com/p/DXhu1GtAXSM/" },
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/47a31d73e26d86ab2fc2e3a14f28de9f.png", url: "https://www.instagram.com/p/DXkqtHmjV5L/" },
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/34c83deea393f617c237d31927323726.png", url: "https://www.instagram.com/p/DavArTaxpXb/" },
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/877df17640bf63756698e91cb6f5c969.png", url: "https://www.instagram.com/p/DaVaA3ZwgrK/" },
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/be6e8a9afae451127125baa61fec67fe.png", url: "https://www.instagram.com/p/DYdU4xftLwv/" },
    { image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/4cbdc09ea2dc5398f536fb8b93902df9.png", url: "https://www.instagram.com/p/DW7CaMrP1e4/" },
  ];

  return (
    <section id="instagram" className="relative w-full py-20 md:py-28 bg-background-100 overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Siga no Instagram
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            @bigmaniasanduiches
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base md:text-lg">
            Acompanhe nosso dia a dia, novidades, promoções e muito sabor no feed.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1} staggerChildren staggerDelay={0.06}>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-10">
            {posts.map((post, idx) => (
              <a
                key={idx}
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer"
              >
                <img
                  src={post.image}
                  alt={`Post Instagram Big Mania ${idx + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/40 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-instagram-line text-2xl text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                </div>
              </a>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal>
          <div className="text-center">
            <a
              href="https://www.instagram.com/bigmaniasanduiches/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-instagram-line text-lg"></i>
              Seguir no Instagram
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}